<template>
  <div class="core-ability-container">
    <div class="ability-card" v-for="(item, index) in abilityList" :key="index">
      <!-- 左侧图片 -->
      <div class="card-img-wrapper">
        <img :src="item.image" :alt="item.title" class="card-img" />
      </div>
      <!-- 右侧文字内容 -->
      <div class="card-content">
        <h3 class="card-title">{{ $t(item.titleKey) }}</h3>
        <p class="card-desc">{{ $t(item.descKey) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreAbility',
  data() {
    return {
      // 核心能力数据（完全匹配截图，可自行修改）
      abilityList: [
        {
          titleKey: 'home.abilities.llm.title',
          descKey: 'home.abilities.llm.desc',
          image: require('@/assets/img/Home/ability/ability01.webp')
        },
        {
          titleKey: 'home.abilities.vision.title',
          descKey: 'home.abilities.vision.desc',
          image: require('@/assets/img/Home/ability/ability02.webp')
        },
        {
          titleKey: 'home.abilities.hardware.title',
          descKey: 'home.abilities.hardware.desc',
          image: require('@/assets/img/Home/ability/ability03.webp')
        },
        {
          titleKey: 'home.abilities.lifecycle.title',
          descKey: 'home.abilities.lifecycle.desc',
          image: require('@/assets/img/Home/ability/ability04.webp')
        }
      ]
    }
  }
}
</script>

<style scoped>
/* 容器：2行2列网格布局 */
.core-ability-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: 4vh 16vh; /* 整体内边距，可根据页面调整 */
  background: #f8f9fa;
}

/* 单个卡片：左图右文 flex 布局 */
.ability-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 卡片hover效果（可选，提升交互感） */
.ability-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

/* 左侧图片容器 */
.card-img-wrapper {
  width: 40%;
  height: 26vh;
  overflow: hidden;
}

/* 图片样式：铺满容器、不变形 */
.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* 右侧文字内容容器 */
.card-content {
  width: 60%;
  padding: 0 4vh;
  box-sizing: border-box;
}

/* 标题样式 */
.card-title {
  font-size: 1.3vw;
  font-weight: bold;
  color: #333;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

/* 描述样式 */
.card-desc {
  font-size: 1vw;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

/* 响应式适配：平板端1列，上下布局 */
@media (max-width: 1024px) {
  .core-ability-container {
    grid-template-columns: 1fr;
    padding: 30px 40px;
  }
  .ability-card {
    flex-direction: column;
  }
  .card-img-wrapper {
    width: 100%;
    height: 220px;
  }
  .card-content {
    width: 100%;
    padding: 24px 30px;
  }
  .card-title {
    font-size: 24px;
  }
  .card-desc {
    font-size: 16px;
  }
}

/* 响应式适配：移动端优化 */
@media (max-width: 768px) {
  .core-ability-container {
    padding: 20px;
    gap: 16px;
  }
  .card-img-wrapper {
    height: 180px;
  }
  .card-content {
    padding: 20px;
  }
  .card-title {
    font-size: 22px;
  }
  .card-desc {
    font-size: 14px;
  }
}
</style>